; (function ($, window, document, undefined) {
    'use strict';
    // nom de librairie à modifier
    Foundation.libs.cartresume = {
        name: 'cartresume', //nom à modifier
        version: '1.0.0',
        settings: {
            callback: function () { }
        },
        windowSize: {
            width: $(window).width(),
            height: $(window).height()
        },

        svgZooms: [],

        init: function (scope, method, options) {
            this.settings = this.settings || $.extend({}, this.defaults, (options || method));
            // à conserver

            this.bindings(method, options);
            Foundation.libs.common.initCarousel();
        },
        events: function () {
            this.initBindings();
        },
        initBindings: function () {
            this.initFullScreenZoom();
            $(this.scope)
                .off('.cart')
                // SOME EVENT
                .on('scroll.fndtn.cart', function (e) {
                }.bind(this))
                // BIND REINIT FORMULAIRE AJOUT PAR REFERENCE
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .reset-add-form', function (e) {
                    e.preventDefault();
                    this.resetAddForm();
                }.bind(this))

                // BIND DELETE CROSS BY MANUAL MODAL
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .m-productInline__delete.a-picto', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var $this = $(e.target);
                    var modalIdSelector = "#" + $this.attr("data-product-modal-id");
                    $(modalIdSelector).foundation('reveal', 'open');
                    $('.m-productReveal .suppr').on("click touchend", function (e) {

                        e.preventDefault();
                        e.stopPropagation();
                        var $this = $(e.target);
                        var $lineId = $this.attr("data-line-id");
                        $(modalIdSelector).foundation('reveal', 'close');
                        $(document).foundation("cartresume", "runDeleteProduct", $lineId);

                    });
                }).bind(this)


                //BIND RADIO BUTTON GAVURE CADEAU
                .on('change.fndtn.cart', '[' + this.attr_name() + '] input[type=radio][name=IsEngravingAccepted]', function (e) {
                    var target = $(e.currentTarget);
                    var elem = $(target.data("element"));

                    if (target.val() === "true") {
                        elem.removeClass('-hidden')
                    } else {
                        elem.addClass('-hidden')
                    }
                }.bind(this))


                //BIND RADIO BUTTON CHOIX CADEAU MULTIPLE
                .on('change.fndtn.cart', '[' + this.attr_name() + '] input[type=radio][name=Reference]', function (e) {

                    var target = $(e.currentTarget);

                    var $elem = $(e.target);
                    var $group = $elem.data("group-id");
                    this.promotionnalGiftMultipleChoice($group, target.val());

                }.bind(this))




                //Bind modification du paquet emotion emballage cadeau du cadeau
                // MESSAGE EMOTION : CLICK SUR AJOUT
                .on('click.fndtn.cart', '[' + this.attr_name() + '] #edit-giftPackage', function (e) {
                    e.preventDefault();
                    var $this = $(e.target);
                    this.editEmballageCadeau($this);
                }.bind(this))
                // BIND BOUTON AJOUT ECRIN
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .jewellerybox-action .js-action', function (e) {
                    var $parent, $this;
                    e.preventDefault();
                    $this = $(e.currentTarget);
                    $parent = $this.parents('.jewellerybox-action');

                    if ($parent.hasClass('-active')) {
                        this.deleteEcrin($this.attr('data-reference'), $this.attr('data-line-number'), $this.attr('data-ecrin'), $this.attr('data-option-id'));
                    } else {
                        this.addEcrin($this.attr('data-reference'), $this.attr('data-line-number'), $this.attr('data-ecrin'));
                    }
                }.bind(this))
                // BIND BOUTON AJOUT GARANTIE
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .warranty-action .js-action', function (e) {
                    var $this, $parent;
                    e.preventDefault();
                    $this = $(e.currentTarget);
                    $parent = $this.parents('.warranty-action');
                    if ($parent.hasClass('-active')) {
                        this.deleteGarantie($this.attr('data-reference'), $this.attr('data-line-number'), $this.attr('data-warranty-reference'), $this.attr('data-option-id'));
                    } else {
                        this.addGarantie($this.attr('data-reference'), $this.attr('data-line-number'), $this.attr('data-warranty-reference'));
                    }
                }.bind(this))

                .on('click.fndtn.cart', '[' + this.attr_name() + '] #bt-paypal-express-checkout', function (e) {
                    e.preventDefault();
                    this.validatePaypalExpressCheckout();
                }.bind(this))


                //Bind suppression gravure
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .m-gravure__delete', function (e) {
                    e.preventDefault();
                    var $elem = $(e.target);
                    var lineId = $elem.attr('data-line-id');
                    var optionId = $elem.attr('data-option-id');
                    this.deleteGravure(optionId, lineId);
                }.bind(this))

                .on('click.fndtn.cart', '[' + this.attr_name() + '] .m-gravure__delete__range', function (e) {
                    e.preventDefault();
                    var $elem = $(e.target);
                    var lineId = $elem.attr('data-line-id');
                    var optionIdRange = $elem.attr('data-option-id');
                    this.deleteGravureRange(optionIdRange, lineId);
                }.bind(this))
                //Bind menu déroulant quantité d'un produit
                .on('change.fndtn.cart', '[' + this.attr_name() + '] .a-select.-quantity', function (e) {
                    e.preventDefault();
                    var $elem = $(e.target);
                    var lineId = $elem.attr('data-line-id');
                    var itemRef = $elem.attr('data-item-ref');
                    var itemVarId = $elem.attr('data-item-variant');
                    var quantity = $elem.val();
                    this.changerQuantite(lineId, quantity, itemRef, itemVarId);
                }.bind(this))


                // BIND CLICK SUR CADEAUX
                .on('change.fndtn.cart', '[' + this.attr_name() + '] .m-promotionnalCode__gift>.a-radio__input', function (e) {
                    var $elem = $(e.target);
                    var group = $elem.data("group-id");
                    var $hasVariants = $elem.data("variants-check");

                    if ($hasVariants == 1) {
                        //Faire poper la popin de choix de taille + faire le set
                        var form = $("#gift-group-" + group);
                        if (form.length > 0)
                            form.submit();

                    } else if ($hasVariants == 0) {
                        var form = $("#gift-group-" + group);
                        if (form.length > 0)
                            form.submit();
                    }
                }.bind(this))
                // BIND CLICK MODIFIER VARIANTE CADEAU
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .changeGiftVariant', function (e) {
                    e.preventDefault();
                    var $elem = $(e.currentTarget);
                    var groupId = $elem.data("gift-group-id");

                    $.ajax({
                        url: '/CartResume/GetGiftVariantPopin',
                        method: "POST",
                        data: { idGroup: groupId },
                        success: function (result) {
                            $(document).foundation('cartresume', 'updateCart', result);

                            if (result.IsValid) {
                                if (result.HasVariants == true) {
                                    $(document).foundation('cartresume', 'selectVariantPromotionnalGiftPopin', result);
                                }
                                Foundation.libs.cartresume.onResizeMovePromoCode();
                                Foundation.libs.common.hidePreloader();
                            }
                            else {
                                Foundation.libs.cartresume.onResizeMovePromoCode();
                                Foundation.libs.common.hidePreloader();
                                // TODO afficher popin
                            }
                        },
                        beforeSend: function () {
                            Foundation.libs.common.showPreloader();
                        }
                    }).fail(function (e) {
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                    });
                }.bind(this))
                // BIND CLICK REFUS CADEAU
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .promotionnalCode-gift-refused', function (e) {
                    e.preventDefault();
                    var $elem = $(e.currentTarget);
                    var $group = $elem.data("group-id");

                    this.promotionnalGiftRefused($group);

                }.bind(this))
                // BIND FINALEMENT JE VEUX MON CADEAU (pas chiant le type...)
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .promotionnalCode-gift-accept', function (e) {
                    e.preventDefault();
                    var $elem = $(e.currentTarget);
                    var groupId = $elem.data("group-id");


                    $.ajax({
                        url: '/CartResume/FinallySetGift',
                        method: "POST",
                        data: { idGroup: groupId },
                        success: function (result) {
                            $(document).foundation('cartresume', 'updateCart', result);

                            if (result.IsValid) {
                                if (result.HasVariants === true) {
                                    $(document).foundation('cartresume', 'selectVariantPromotionnalGiftPopin', result);
                                }
                                Foundation.libs.cartresume.onResizeMovePromoCode();
                                Foundation.libs.common.hidePreloader();
                            }
                            else {
                                Foundation.libs.cartresume.onResizeMovePromoCode();
                                Foundation.libs.common.hidePreloader();
                                // TODO afficher popin
                            }
                        },
                        beforeSend: function () {
                            Foundation.libs.common.showPreloader();
                        }
                    }).fail(function (e) {
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                    });
                }.bind(this))

                //Bind suppression d'un cadeau promotionnel choisi dans panier
                .on('click.fndtn.cart', '[' + this.attr_name() + '] [id^=delete-line-gift-]', function (e) {
                    e.preventDefault();
                    var $elem = $(e.target);
                    var $group = $elem.attr("data_group_id");
                    this.promotionnalGiftRefused($group);
                }.bind(this))
                //suppression cadeau promo via checkbox
                .on('click.fndtn.cart', '[' + this.attr_name() + '] [id^=checkbox-delete-line-gift-]', function (e) {
                    e.preventDefault();
                    var $elem = $(e.target);
                    var $group = $elem.attr("data_group_id");
                    this.promotionnalGiftRefused($group);
                }.bind(this))

                //BTN ADD ITEM BY REF MERCHAREASPRODUCTS
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .add-product-from-carousel', function (e) {
                    e.preventDefault();
                    var $this = $(e.currentTarget);
                    var itemRef = $this.data('itemRef');
                    var quantity = $this.data('itemQty');

                    if (itemRef !== undefined) {
                        this.addProductFromMerchandisingAreas(itemRef);
                    }
                }.bind(this))
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .m-gravure__toggle', function (e) {
                    e.preventDefault();
                    var $this = $(e.currentTarget);
                    var $parent = $this.parents(".m-gravure");
                    $parent.toggleClass("-open");
                }.bind(this))


                .on('click.fndtn.cart', '[' + this.attr_name() + '] .m-gravure__delete__gift', function (e) {
                    e.preventDefault();

                    var $this = $(e.currentTarget);
                    var formId = $this.data("form-id");

                    $(formId).submit();
                }.bind(this))
                //event on promo code
                .on('click.fndtn.cart', '[' + this.attr_name() + '] #btnAddPromo', function (e) {
                    var code = document.getElementById("Code").value.trim();
                    if (code.length == 0) {
                        e.preventDefault();
                        this.emptyPromoCode("champ vide");
                    }
                }.bind(this))
                //Binding for giftpackage text

                .on('keyup.fndtn.cart', '#EngravingText', function (e) {
                    var targetInput = $(e.currentTarget);
                    var targetSpan = targetInput.parents('.m-inputWrapper').find('.m-inputWrapper__counter span');
                    var maxLength = parseInt(targetInput.attr('maxlength'));
                    var inputLength = targetInput.val().replace(/\n/g, "\r\n").length;
                    var text = maxLength - inputLength;

                    targetSpan.text(text);

                }.bind(this))
                .on('blur.fndtn.cart change.fndtn.cart', '#EngravingText', function (e) {
                    var targetInput = $(e.currentTarget);
                    var originalText = targetInput.val();
                    var maxChar = parseInt(targetInput.attr("maxlength"));
                    var nbCarRestants = maxChar - originalText.replace(/\n/g, "\r\n").length;  // le replace '/n' => '\r\n' permet de prendre en compte les retours chariot dans le calcul de la longueur (sinon val().length ne tient pas compte des retours à la ligne)

                    if (nbCarRestants < 0) {
                        var newText = originalText.replace(/\n/g, "\r\n").substring(0, maxChar).replace(/\r\n/g, "\n");
                        targetInput.val(newText);
                    }
                }.bind(this))

                .on('keyup.fndtn.cart', '[' + this.attr_name() + '] .count-nb-caracteres', function (e) {
                    var targetInput = $(e.currentTarget);
                    var targetSpan = targetInput.parents('.m-inputWrapper').find('.m-inputWrapper__counter span');
                    var maxLength = parseInt(targetInput.attr('maxlength'));
                    var inputLength = targetInput.val().replace(/\n/g, "\r\n").length;
                    var text = maxLength - inputLength;

                    targetSpan.text(text);

                }.bind(this))
                .on('blur.fndtn.cart change.fndtn.cart', '[' + this.attr_name() + '] .count-nb-caracteres', function (e) {
                    var targetInput = $(e.currentTarget);
                    var originalText = targetInput.val();
                    var maxChar = parseInt(targetInput.attr("maxlength"));
                    var nbCarRestants = maxChar - originalText.replace(/\n/g, "\r\n").length;  // le replace '/n' => '\r\n' permet de prendre en compte les retours chariot dans le calcul de la longueur (sinon val().length ne tient pas compte des retours à la ligne)

                    if (nbCarRestants < 0) {
                        var newText = originalText.replace(/\n/g, "\r\n").substring(0, maxChar).replace(/\r\n/g, "\n");
                        targetInput.val(newText);
                    }
                }.bind(this))

                .on('click.fndtn.cart', '[' + this.attr_name() + ' ] .checkboxSubmit', function (e) {
                    e.preventDefault();
                    if (!$(e.currentTarget).is(":checked")) {
                        var $this = $(e.currentTarget);


                        var $idEmotionMessageOption = $("#IdEmotion").val();
                        this.deleteEmballageCadeau($idEmotionMessageOption);

                    }
                    else {
                        var $this = $(e.currentTarget);
                        if ($this.parents(".m-giftPackage").hasClass("-active")) {
                            $("#form-add-emotion-message").submit();
                        }
                        else {
                            this.editEmballageCadeau($this);

                        }
                    }


                }.bind(this))
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .update-engraving-with-preview', function (e) {
                    var element = e.currentTarget;
                    var ref = $(element).attr('data-reference');
                    var codeEmplacement = $(element).attr('data-code-emplacement');
                    var fontFamily = $(element).attr('data-font-family');
                    var loadModel = {
                        Reference: ref,
                        LocationCode: codeEmplacement,
                        FontFamily: fontFamily
                    }

                    $.ajax({
                        url: '/engraving/LoadEngravingPreview',
                        data: loadModel,
                        cache: false,
                        beforeSend: function (data) {
                            $('#preloader').show();
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                $('#engraving-preview-modal').html(result._Preview);
                                $('#engraving-preview-modal').foundation('reveal', 'open');
                                $('#engraving-preview-modal').on('opened.fndtn.reveal', function (e) {
                                    Foundation.libs.gravure.bindInputsToSvg();
                                });
                            }
                        },
                        complete: function (data) {
                            $('#preloader').fadeOut();
                        }
                    });
                }.bind(this))
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .shownGiftPackagePreview', function (e) {
                    e.preventDefault();

                    // On affiche la preview
                    $("#giftPackagePreview").show("slow");

                    // On scroll vers la preview
                    $(document).foundation("scroll", "moveTo", $("#giftPackagePreview"));
                }.bind(this))

                .on('click.fndtn.cart', '[' + this.attr_name() + '] .btn-validation-step1', function (e) {
                    e.preventDefault();
                    this.validerPanier();
                }.bind(this))

                .on('keyup.fndtn.cart', '[' + this.attr_name() + '] .giftPackageLine', function (e) {
                    e.preventDefault();
                    var $elem = $(e.target);
                    var line = $elem.attr('data-line-number');
                    var input = $elem.val();
                    var lastWord = "";

                    // Si ligne pleine (nb max de cara)
                    if (input.length == 65) {
                        // Si on appuie sur ENTRER
                        if (e.keyCode == 13) {
                            // Si on n'est pas sur la dernière ligne, on passe à la ligne du dessous
                            if (line < 9) {
                                $("#Line" + (parseInt(line) + 1)).focus();
                                Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + (parseInt(line) + 1)));
                            }
                        } // Si on appuie sur la touche flèche HAUT, on passe à la ligne du dessus
                        else if (e.keyCode == 38) {
                            // Si on n'est pas sur la première ligne, on passe à la ligne du dessus
                            if (line > 1) {
                                $("#Line" + (parseInt(line) - 1)).focus();
                                Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + (parseInt(line) - 1)));
                            }
                        } // Si on appuie sur la touche flèche BAS, on passe à la ligne du dessous
                        else if (e.keyCode == 40) {
                            // Si on n'est pas sur la dernière ligne, on passe à la ligne du dessous
                            if (line < 9) {
                                $("#Line" + (parseInt(line) + 1)).focus();
                                Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + (parseInt(line) + 1)));
                            }
                        } // Si on est en bout de ligne
                        else {
                            // Si on n'est pas sur la dernière ligne, on passe à la ligne du dessous
                            if (line < 9) {
                                // Si on ne fait pas un espace, on est en train d'écrire un mot complet
                                if (e.keyCode != 32) {
                                    // On récupère le dernier mot de la ligne actuelle
                                    lastWord = this.getLastWord($("#Line" + (parseInt(line))).val());

                                    // On supprime de la ligne actuelle le dernier mot
                                    var rem = this.removeLastWord($("#Line" + (parseInt(line))).val());

                                    // On réécrit la ligne actuelle sans le mot supprimé
                                    $("#Line" + (parseInt(line))).val(rem);
                                    // Il faut aussi mettre à jour le SVG
                                    //$("#giftPackageLinePreview" + line).html(rem);

                                    // On écrit le dernier sur la ligne suivante
                                    $("#Line" + (parseInt(line) + 1)).val(lastWord);
                                }

                                $("#Line" + (parseInt(line) + 1)).focus();
                                Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + (parseInt(line) + 1)));
                            }
                        }
                    } // Si ligne vide
                    else if (input.length == 0) {
                        // Si on appuie sur BACK ou fleche HAUT
                        if (e.keyCode == 8 || e.keyCode == 38) {
                            // Si on n'est pas sur la première ligne, on passe à la ligne du dessus
                            if (line > 1) {
                                $("#Line" + (parseInt(line) - 1)).focus();
                                Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + (parseInt(line) - 1)));
                            }
                        } // Si on appuie sur la touche flèche BAS, on passe à la ligne du dessous
                        else if (e.keyCode == 40) {
                            // Si on n'est pas sur la dernière ligne, on passe à la ligne du dessous
                            if (line < 9) {
                                $("#Line" + (parseInt(line) + 1)).focus();
                                Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + (parseInt(line) + 1)));
                            }
                        } // Si on appuie sur la touche ENTRER
                        else if (e.keyCode == 13) {
                            // Si on n'est pas sur la dernière ligne, on passe à la ligne du dessous
                            if (line < 9) {
                                $("#Line" + (parseInt(line) + 1)).focus();
                                Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + (parseInt(line) + 1)));
                            }
                        }
                    } // Si fleche HAUT
                    else if (e.keyCode == 38) {
                        // Si on n'est pas sur la première ligne, on passe à la ligne du dessus
                        if (line > 1) {
                            $("#Line" + (parseInt(line) - 1)).focus();
                            Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + (parseInt(line) - 1)));
                        }
                    } // si fleche BAS
                    else if (e.keyCode == 40) {
                        // Si on n'est pas sur la dernière ligne, on passe à la ligne du dessous
                        if (line < 9) {
                            $("#Line" + (parseInt(line) + 1)).focus();
                            Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + (parseInt(line) + 1)));
                        }
                    } // si ENTRER
                    else if (e.keyCode == 13) {
                        // Si on n'est pas sur la dernière ligne, on passe à la ligne du dessous
                        if (line < 9) {
                            $("#Line" + (parseInt(line) + 1)).focus();
                            Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + (parseInt(line) + 1)));
                        }
                    }
                    // Sinon on écrit dans la zone
                    else {
                        //$("#giftPackageLinePreview" + line).html(input);
                    }

                    // On met à jour le SVG de la preview
                    Foundation.libs.cartcommon.refreshSvgGiftCardPreview();
                }.bind(this))
                // MESSAGE EMOTION : TOUCHE ENTREE
                .on('keypress.fndtn.cart', '[' + this.attr_name() + '] #form-add-emotion-message', function (e) {
                    var code = e.keyCode || e.which;

                    // On bloque la validation du formulaire sur la touche entrée
                    if (code == 13) {
                        e.preventDefault();
                        return false;
                    }
                }.bind(this))
                .on('click.fndtn.shipping', '[' + this.attr_name() + '] #clickncollectV2-checkbox-gift', function (event) {
                    var $this = event.currentTarget;

                    $.ajax({
                        url: '/CartResume/SetGiftWanted',
                        beforeSend: function (e) {
                            Foundation.libs.common.showPreloader();
                        },
                        success: function (result) {
                            if (result.IsValid) {
                                if (!result.IsException) {
                                    $(document).foundation('cartresume', 'updateCart', result);
                                }
                                Foundation.libs.cartresume.onResizeMovePromoCode();

                                Foundation.libs.common.hidePreloader();
                            }
                            else {
                                Foundation.libs.cartresume.onResizeMovePromoCode();

                                Foundation.libs.common.hidePreloader();
                            }
                        }
                    }).fail(function (result) {
                        Foundation.libs.cartresume.onResizeMovePromoCode();

                        Foundation.libs.common.hidePreloader();
                    });
                }.bind(this))
                // MESSAGE CARTE CADEAU : AFFICHER
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .gift-card__message', function (e) {
                    let clickedElement = e.originalEvent.target;
                    let elId = $(clickedElement).data('line-id');
                    let message = $('.gift-card__message.-message[data-line-id="' + elId + '"]');

                    if (message.length == 1) {
                        if (!clickedElement.classList.contains('-active')) {

                            let height = 0;
                            message.children().each((index, item) => { height += $(item).height() })
                            message.css('height', height + 5 + 'px')

                            message.addClass('-active');
                            $(clickedElement).addClass('-active');

                        } else {

                            let height = 0;
                            message.css('height', height + 'px')

                            message.removeClass('-active');
                            $(clickedElement).removeClass('-active');

                        }
                    }
                }.bind(this))
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .gift-card__edit', function (e) {
                    e.preventDefault();
                    var element = e.currentTarget;
                    var product = $(element).attr('data-product-reference');
                    var id = $(element).attr('data-line-id');

                    window.location = '/Product/EditGiftCardMessageFromCart/?productId=' + product + '&itemId=' + id;
                }.bind(this))
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .egift-card__edit', function (e) {
                    e.preventDefault();
                    var element = e.currentTarget;
                    var product = $(element).attr('data-product-reference');
                    var id = $(element).attr('data-line-id');

                    window.location = '/Product/EditEGiftCardFromCart/?productId=' + product + '&itemId=' + id;
                }.bind(this))
                .on('click.fndtn.cart', '[' + this.attr_name() + '] .egift-card__message', function (e) {
                    let clickedElement = e.originalEvent.target;
                    let elId = $(clickedElement).data('line-id');
                    let message = $('.egift-card__message.-message[data-line-id="' + elId + '"]');

                    if (message.length == 1) {
                        if (!clickedElement.classList.contains('-active')) {

                            let height = 0;
                            message.children().each((index, item) => { height += $(item).height() })
                            message.css('height', height + 10 + 'px')

                            message.addClass('-active');
                            $(clickedElement).addClass('-active');

                        } else {

                            let height = 0;
                            message.css('height', height + 'px')

                            message.removeClass('-active');
                            $(clickedElement).removeClass('-active');

                        }
                    }
                }.bind(this))
                .on('click.fndtn.cart', '.modal-gift__actions .action .a-radio__input', function (e) {

                    var input = $(e.currentTarget);
                    if (input.is("#oui")) {
                        $("#gift-engraving-input-wrapper").show();
                    }
                    else if (input.is("#non")) {
                        $("#gift-engraving-input-wrapper").hide();
                    }
                }.bind(this))

                .on('click.fndtn.cart', '#submit-engraving-form', function (e) {
                    Foundation.libs.cartcommon.InitGlobal();


                }.bind(this));



        },
        giftPackageFocus: function () {
            // On determine la dernière ligne avec du texte
            var line = 1;
            for (var i = 9; i >= 1; i--) {
                if ($("#Line" + (i)).val().length > 0) {
                    line = i;
                    break;
                }
            }

            // On focus et on se place en fin de ligne
            $("#Line" + line).focus();
            Foundation.libs.cartcommon.moveCursorToEnd($("#Line" + line));
            // On scroll toujours sur la 1ere ligne
            $(document).foundation("scroll", "moveTo", $("#Line1"));
        },
        getLastWord: function (words) {
            var n = words.split(" ");
            return n[n.length - 1];
        },
        removeLastWord: function (str) {
            var lastIndex = str.lastIndexOf(" ");

            str = str.substring(0, lastIndex);

            return str;
        },
        deleteGravure: function (optionId, lineId) {
            $.ajax({
                url: '/CartResume/RemoveEngraving',
                method: "POST",
                data: {
                    optionId: optionId,
                    lineNumber: lineId
                },
                complete: function (result) {
                    if (result.responseJSON.IsValid) {
                        Foundation.libs.cartresume.updateCartAfterEngravings(result.responseJSON, lineId);
                    }
                    Foundation.libs.cartresume.onResizeMovePromoCode();
                    Foundation.libs.common.hidePreloader();
                },
                beforeSend: function () {
                    Foundation.libs.common.showPreloader();
                }
            }).fail(function (e) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },
        deleteGravureRange: function (optionIdRange, lineId) {
            $.ajax({
                url: '/CartResume/RemoveEngravingRange',
                method: "POST",
                data: {
                    optionIdRange: optionIdRange,
                    lineNumber: lineId
                },
                complete: function (result) {
                    if (result.responseJSON.IsValid) {
                        Foundation.libs.cartresume.updateCartAfterEngravings(result.responseJSON, lineId);
                    }
                    Foundation.libs.cartresume.onResizeMovePromoCode();
                    Foundation.libs.common.hidePreloader();
                },
                beforeSend: function () {
                    Foundation.libs.common.showPreloader();
                }
            }).fail(function (e) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },

        accepterCadeauNonOptionnel: function (referenceCadeau) {
            $.ajax({
                url: '/Cart/AjouterCadeauNonOptionnel',
                data: { reference: referenceCadeau },
                success: function (result) {
                    $(document).foundation('cartresume', 'updateCart', result);
                    Foundation.libs.cartresume.onResizeMovePromoCode();
                    Foundation.libs.common.hidePreloader();
                },
                beforeSend: function () {
                    Foundation.libs.common.showPreloader();
                }
            }).fail(function (e) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },

        refuserCadeauNonOptionnel: function (referenceCadeau) {
            $.ajax({
                url: '/Cart/RefuserCadeauNonOptionnel',
                data: { reference: referenceCadeau },
                success: function (result) {
                    $(document).foundation('cartresume', 'updateCart', result);
                    Foundation.libs.cartresume.onResizeMovePromoCode();
                    Foundation.libs.common.hidePreloader();
                },
                beforeSend: function () {
                    Foundation.libs.common.showPreloader();
                }
            }).fail(function (e) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },

        changerQuantite: function (lineId, quantity, itemRef, itemVar) {
            if (quantity > 1) {
                this.addMultipleProductsByRef(itemRef, itemVar, quantity);
            }
        },
        validerPanier: function () {
            $.ajax({
                url: '/CartResume/ValidateProductListStep',
                success: function (result) {
                    if (result.IsValid) {
                        if (result.Redirection !== "" && result.Redirection !== undefined) {
                            document.location.href = result.Redirection;
                        }
                    }
                    else {
                        if (result.Redirection !== "" && result.Redirection !== undefined) {
                            document.location.href = result.Redirection;
                        }
                        else {
                            $(document).foundation('cartresume', 'updateCart', result);
                            //if (result.IsShowModalShippingUpdates) {
                            //    // On affiche la modal
                            //    var popinShippingMethodUpdate = $("#shipping-method-updated");

                            //    popinShippingMethodUpdate.html(result._ShippingUpdateModal);

                            //    popinShippingMethodUpdate.foundation('reveal', 'open');
                            //}
                        }

                        Foundation.libs.cartresume.onResizeMovePromoCode();

                        Foundation.libs.scroll.moveTo($("#error-messages-wrapper"));

                        Foundation.libs.common.hidePreloader();
                    }
                }
            })

            var event = {
                obj: "",
                trigger: 'validation_panier',
                options: {
                    id: "checkout_progress",
                    category: "panier",
                    action: "",
                    label: "",
                    value: ""
                }
            };

            $(document).foundation('mastertag', 'track_tc_event', event);
        },
        resetAddForm: function () {
            $.ajax(
                {
                    url: '/Cart/ResetAddForm',
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    complete: function (result) {
                        if (result.responseJSON.IsValid) {
                            Foundation.libs.cartresume.updateComponent("ajoutParRef", result.responseJSON._SectionAjoutParRef);
                            Foundation.libs.cartresume.onResizeMovePromoCode();
                            Foundation.libs.common.hidePreloader();
                        }
                        else {
                            Foundation.libs.cartresume.onResizeMovePromoCode();
                            Foundation.libs.common.hidePreloader();
                        }
                    }
                }
            ).fail(function (e) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },
        totallyDeleteProduct: function ($elem, $result) {
            this.updateCartAfterDelete($result);

            if (typeof ($elem) != "undefined") {
                setTimeout(function () {
                    $elem.slideUp(function () {
                        $elem.remove();
                        Foundation.libs.cartresume.updateCartAfterDelete($result);
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                    });
                }, 300);
            }
        },

        // SUPPRESSION PRODUIT MÉTIER
        runDeleteProduct: function ($lineId) {
            var $contents;
            var $elem = $("#line-" + $lineId);

            $.ajax(
                {
                    url: '/CartResume/RemoveItem',
                    method: 'POST',
                    data: {
                        itemId: $lineId
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    complete: function (result) {
                        if (result.responseJSON.IsValid) {
                            $contents = $elem.find('.delete-product-in-progress, .delete-product-message');
                            $contents.toggle();
                            Foundation.libs.cartresume.totallyDeleteProduct($elem, result.responseJSON);
                            Foundation.libs.common.hidePreloader();
                        }
                        else {
                            Foundation.libs.cartresume.totallyDeleteProduct($elem, result.responseJSON);
                        }

                        // Tracking via TagCo
                        $(document).foundation('mastertag', 'track_tc_event',
                            {
                                obj: this,
                                trigger: 'retrait_produit',
                                options: {
                                    id: 'retrait_produit',
                                    category: 'panier',
                                    action: 'retrait produit',
                                    label: result.responseJSON._RemovedItem.product_name + '|' + result.responseJSON._RemovedItem.product_id,
                                    value: result.responseJSON._RemovedItem.product_unitprice_ati,
                                    product_cat1: result.responseJSON._RemovedItem.product_cat1,
                                    product_cat2: result.responseJSON._RemovedItem.product_cat2,
                                    product_cat3: result.responseJSON._RemovedItem.product_cat3,
                                    product_category: result.responseJSON._RemovedItem.product_category,
                                    product_discount_tf: result.responseJSON._RemovedItem.product_discount_tf,
                                    product_discount_ati: result.responseJSON._RemovedItem.product_discount_ati,
                                    product_gravable: result.responseJSON._RemovedItem.product_gravable,
                                    product_engraved: result.responseJSON._RemovedItem.product_engraved,
                                    product_id: result.responseJSON._RemovedItem.product_id,
                                    product_name: result.responseJSON._RemovedItem.product_name,
                                    product_promo: result.responseJSON._RemovedItem.product_promo,
                                    product_promo_label: result.responseJSON._RemovedItem.product_promo_label,
                                    product_quantity: result.responseJSON._RemovedItem.product_quantity,
                                    product_rating: result.responseJSON._RemovedItem.product_rating,
                                    product_size: result.responseJSON._RemovedItem.product_size,
                                    product_trademark: result.responseJSON._RemovedItem.product_trademark,
                                    product_unitprice_ati: result.responseJSON._RemovedItem.product_unitprice_ati,
                                    product_unitprice_tf: result.responseJSON._RemovedItem.product_unitprice_tf
                                }
                            });

                        $(document).foundation('common', 'refreshMasterTagData', result._MasterTagJson);
                        $(document).foundation('common', 'refreshMasterTag');

                        Foundation.libs.cartresume.onResizeMovePromoCode();

                        LoadEngravingPreviewFont();

                        Foundation.libs.common.hidePreloader();

                        if (result.responseJSON._HellobarCart && result.responseJSON._HellobarCart.length > 0) {
                            $(".cart__header .hellobars").remove();
                            $('.cart__header').prepend(result.responseJSON._HellobarCart);

                            Foundation.libs.promo.initHellobars();
                        }
                    }
                }
            ).fail(function (result) {
                $contents = $elem.find(".product-content");
                $(document).foundation('common', 'toggleAnimation', { contents: $contents });
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });

        },
        updateEmballageCadeau: function () {
            var $contents;
            var $contents = $('#emballage-cadeau-component .formulaire, #emballage-cadeau-component .formulaire-complete');
            $(document).foundation('common', 'toggleAnimation', { contents: $contents });

        },

        editEmballageCadeau: function ($this) {
            // ajouter code pour fermer la première partie et garder la même valeur pour le input au cas où
            var $contents, $giftPackageForm, $giftPackageMessageLine;
            var $parent = $this.parents('.m-giftPackage');
            if (!$parent.hasClass("-actived")) {
                $parent.toggleClass("-active");
            }
            var $giftPackageForm = $('#giftPackageMessageLine');
            var $giftPackageFirst = $('#giftPackageFirstMessage');
            $giftPackageForm.toggleClass("-off");
            $giftPackageFirst.toggleClass("-off");

            if ($giftPackageForm.hasClass("-off")) {
                $giftPackageForm.removeAttr("style");
            }
            // LIGNE 1 DU MESSAGE
            this.giftPackageFocus();
        },

        deleteEmballageCadeau: function (idEmotionMessageOption) {
            var $contents;

            $.ajax(
                {
                    url: '/CartResume/RemoveEmotionMessage',
                    contentType: "application/json",
                    data: {
                        idEmotionMessageOption: idEmotionMessageOption,
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    complete: function (result) {
                        if (result.responseJSON.IsValid) {
                            Foundation.libs.cartresume.updateCartAfterEmballageCadeau(result.responseJSON);
                        }
                        else {
                            Foundation.libs.cartresume.updateCartAfterEmballageCadeau(result.responseJSON);
                        }
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.updateCartAfterEmballageCadeau(result.responseJSON);
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },

        showErrorsEmballageCadeau: function (erreurs) {
            var $errorsWrapper = $("#emballage-cadeau-errors-wrapper");
            var messages = '';
            for (var i = 0; i < erreurs.length; i++) {
                messages += '<p>' + erreurs[i] + '</p>';
            }
            $errorsWrapper.hide().html(messages).fadeIn();
        },

        deleteCodePromo: function () {
            var $contents;

            $.ajax(
                {
                    url: '/CartResume/RemovePromoCode',

                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    complete: function (result) {
                        if (result.responseJSON.IsValid) {
                            Foundation.libs.cartresume.updateCart(result.responseJSON);
                        }
                        else {
                            Foundation.libs.cartresume.updateCart(result.responseJSON);
                        }
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                        $(document).foundation('reveal', 'reflow');
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.updateCart(result.responseJSON);
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },

        // ACCORDEON GRAVURE SUR MOBILE
        toggleGravure: function ($elem) {
            $elem.toggleClass('-active');
        },

        // ANIMATION TOGGLE MESSAGE AU CLICK
        toggleMessage: function ($elem) {
            var $contents;
            $contents = $elem.find('.formulaire, .suppr');
            if (this.windowSize.width > 640) {
                $elem.find('.ajout .custom-button').fadeToggle();
            } else {
                $(document).foundation('common', 'toggleAnimation', { contents: $elem.find('.ajout .custom-button') });
            }

            $(document).foundation('common', 'toggleAnimation', { contents: $contents });
        },

        missingVariantToAddPopin: function (result) {
            //reveal popin
            this.updateComponent("popinVarianteAjout", result._SectionPopinAddByRef);
            $('#step-1_popin_product_add').foundation('reveal', 'open');
        },

        modifyEngravingPopin: function (result) {
            this.updateComponent("popinModifyEngraving", result._Preview);
            $('#product-engraving-popin').foundation('reveal', 'open');
        },

        selectVariantPromotionnalGiftPopin: function (result) {
            this.updateComponent("popinPromotionnalGift", result._SectionPopinPromotionnalGift);
            $('#promotionnalCode-gift-popin').foundation('reveal', 'open');
        },

        updateMasterTagDataLayer: function (result) {
            if (typeof (result) != "undefined" && typeof (result._MasterTagJson) != "undefined" && result._MasterTagJson.length > 0) {
                $(document).foundation('common', 'refreshMasterTagData', result._MasterTagJson);
                $(document).foundation('common', 'refreshMasterTag');
            }
        },

        updateCart: function (result, callback, callbackParameter) {
            this.updateComponent("etape1Panier", result._SectionTotalBasket)
            Foundation.libs.common.updateArticlesInCart();

            this.updateMasterTagDataLayer(result);
            Foundation.libs.common.initCarousel();
            Foundation.libs.cartcommon.InitGlobal();

        },
        updateCartErrors: function (errors) {
            this.updateComponent("summaryErrors", errors);
        },
        updateCartAfterAdd: function (result) {
            if (result.IsIdle) {
                this.updateCart(result);
            } else {
                this.updateComponent("etape1Panier", result._SectionTotalBasket);
                this.updateComponent("zoneAjoutParRef", result._SectionAddByRef);

                $('#step-1_popin_product_add').foundation('reveal', 'close');
                $(document).foundation('reveal', 'reflow');

                this.updateMasterTagDataLayer(result);
                Foundation.libs.common.initCarousel();
                Foundation.libs.cartcommon.InitGlobal();

            }
        },

        updateCartAfterDelete: function (result) {
            this.updateComponent("etape1Panier", result._SectionTotalBasket);
            this.updateComponent("zoneAjoutParRef", result._SectionAddByRef);

            $(document).foundation('reveal', 'reflow');
            this.updateMasterTagDataLayer(result);
            Foundation.libs.common.initCarousel();
            Foundation.libs.cartcommon.InitGlobal();

        },

        updateCartAfterEmballageCadeau: function (result) {
            this.updateComponent("emballageCadeau", result._SectionGiftPackage);
            this.updateComponent("affichageProduitSummary", result._SectionBasketSummary);

            $('#pfp-messages-wrapper').html(result._SectionPFPMessages);
            $('#marketing-messages-wrapper').html(result._SectionMarketingMessages);
            if (result._SectionErrorMessages != null && result._SectionErrorMessages.length > 0) {
                if ($(".subbaskets__message").find("#error-messages-wrapper").length > 0) {
                    $("#error-messages-wrapper").html(result._SectionErrorMessages)
                }
                else {

                    $(".subbaskets__message").append('<div id="error-messages-wrapper" class="message -error">' + result._SectionErrorMessages + '</div>')
                }
            }
            else {
                $("#error-messages-wrapper").remove();
            }
            //obligatoire car utilisé dans main-layout.js qui n'est pas rappelé après le chargement de la partial
            $('.m-dropdown__link').on("click", function (event) {
                event.preventDefault();
                var $parent = $(event.target).parents('.m-dropdown');
                $parent.toggleClass("-active");
            });
            Foundation.libs.cartcommon.InitGlobal();

            Foundation.libs.common.refreshMasterTagData(result._MasterTagJson, true);
            Foundation.libs.common.refreshMasterTag();
        },
        updateErrorsEmballageCadeauForm: function (result) {
            this.updateComponent("emballageCadeau", result._SectionGiftPackage);

            var $content = $('#gift-package-content');

            $content.toggleClass("-off");
            $("#giftPackageMessageLine").show();

            var $mainPart = $(".m-giftPackage");
            if ($mainPart.hasClass("-active") == false) {
                $mainPart.addClass("-active");
            }

            var $giftPackageForm = $('#giftPackageMessageLine');
            var $giftPackageFirst = $('#giftPackageFirstMessage');
            $giftPackageForm.toggleClass("-off");
            $giftPackageFirst.toggleClass("-off");

            //$("#edit-giftPackage").hide();

            //obligatoire car utilisé dans main-layout.js qui n'est pas rappelé après le chargement de la partial
            $('.m-dropdown__link').on("click", function (event) {
                event.preventDefault();
                var $parent = $(event.target).parents('.m-dropdown');
                $parent.toggleClass("-active");
            });

            Foundation.libs.common.refreshMasterTagData(result._MasterTagJson, true);
            Foundation.libs.common.refreshMasterTag();
        },
        updateListeProduits: function (result) {
            this.updateComponent("listeProduits", result._SectionListeProduits);
            this.updateComponent("panierVide", result._EmptyCart);
            Foundation.libs.cartcommon.InitGlobal();

        },
        updateCartAfterEngravings: function (result, idItem) {
            this.updateDynamicComponent("ligneArticle", idItem, result._SectionProductLine);
            this.updateComponent("affichageProduitSummary", result._SectionBasketSummary);
            if (result._SectionErrorMessages != null && result._SectionErrorMessages.length > 0) {
                if ($(".subbaskets__message").find("#error-messages-wrapper").length > 0) {
                    $("#error-messages-wrapper").html(result._SectionErrorMessages)
                }
                else {

                    $(".subbaskets__message").append('<div id="error-messages-wrapper" class="message -error">' + result._SectionErrorMessages + '</div>')
                }
            }
            else {
                $("#error-messages-wrapper").remove();
            }
            Foundation.libs.cartcommon.InitGlobal();

            Foundation.libs.common.refreshMasterTagData(result._MasterTagJson, true);
            Foundation.libs.common.refreshMasterTag();
        },
        updateCartAfterWarranty: function (result, idItem) {

            this.updateDynamicComponent("garantieArticle", idItem, result._SectionProductWarrantyLine);
            this.updateComponent("affichageProduitSummary", result._SectionBasketSummary);

            $('#pfp-messages-wrapper').html(result._SectionPFPMessages);
            $('#marketing-messages-wrapper').html(result._SectionMarketingMessages);
            if (result._SectionErrorMessages != null && result._SectionErrorMessages.length > 0) {
                if ($(".subbaskets__message").find("#error-messages-wrapper").length > 0) {
                    $("#error-messages-wrapper").html(result._SectionErrorMessages)
                }
                else {

                    $(".subbaskets__message").append('<div id="error-messages-wrapper" class="message -error">' + result._SectionErrorMessages + '</div>')
                }
            }
            else {
                $("#error-messages-wrapper").remove();
            }
            Foundation.libs.cartcommon.InitGlobal();

            Foundation.libs.common.refreshMasterTagData(result._MasterTagJson, true);
            Foundation.libs.common.refreshMasterTag();
        },
        updateCartAfterJewelleryBox: function (result, idItem) {
            this.updateDynamicComponent("ecrinArticle", idItem, result._SectionProductJewelleryBoxLine);
            this.updateComponent("affichageProduitSummary", result._SectionBasketSummary);

            $('#pfp-messages-wrapper').html(result._SectionPFPMessages);
            $('#marketing-messages-wrapper').html(result._SectionMarketingMessages);
            if (result._SectionErrorMessages != null && result._SectionErrorMessages.length > 0) {
                if ($(".subbaskets__message").find("#error-messages-wrapper").length > 0) {
                    $("#error-messages-wrapper").html(result._SectionErrorMessages)
                }
                else {

                    $(".subbaskets__message").append('<div id="error-messages-wrapper" class="message -error">' + result._SectionErrorMessages + '</div>')
                }
            }
            else {
                $("#error-messages-wrapper").remove();
            }
            Foundation.libs.cartcommon.InitGlobal();

            Foundation.libs.common.refreshMasterTagData(result._MasterTagJson, true);
            Foundation.libs.common.refreshMasterTag();
        },
        updateCartAfterPromotionnalGiftChoice: function (result) {
            this.updateCart(result);
            $('#promotionnalCode-gift-popin').foundation('reveal', 'close');
            this.updateMasterTagDataLayer(result);

            var $zoneAjoutPanier = $("#sub-basketmaty_gifts").first();
        },

        updateDynamicComponent: function (name, dynamicSelector, content, callback, callbackParameter) {
            var zone = this.selectDynamicComponent(name, dynamicSelector)
            zone.html(content);

            if (callback && callbackParameter) {
                callback(callbackParameter);
            }
            else if (callback) {
                callback();
            }
        },

        updateComponent: function (name, content, callback, callbackParameter) {

            var zone = this.selectComponent(name)
            zone.html(content);

            if (callback && callbackParameter) {
                callback(callbackParameter);
            }
            else if (callback) {
                callback();
            }
        },
        initFullScreenZoom: function () {
            // Gestion du Zoom en popin fullscreen
            var zoomRevealSettings = {
                close_on_background_click: true,
                close_on_esc: true,
                dismiss_modal_class: 'close-reveal-modal',
                bg_class: 'reveal-modal-bg'
            };
        },

        selectDynamicComponent: function (name, dynamicSelector) {
            var elem;

            switch (name) {
                case "garantieArticle":
                    elem = $('#warranty-option-' + dynamicSelector);
                    break;
                case "ecrinArticle":
                    elem = $('#box-option-' + dynamicSelector);
                    break;
                case "ligneArticle":
                    elem = $('#resume-item-' + dynamicSelector);
                    break;
                default:
                    elem = null;
            }

            return elem;
        },

        selectComponent: function (name) {
            var elem;

            switch (name) {
                case "zonesMerchPanier":
                    elem = $("#basket-merch-areas");
                    break;
                case "affichageProduitSummary":
                    elem = $('#cart-summary');
                    break;
                case "etape1Panier":
                    elem = $('#panierResume');
                    break;
                case "zoneAjoutParRef":
                    elem = $('#ajout-panier-component');
                    break;
                case "popinVarianteAjout":
                    elem = $('#step-1_popin_product_add');
                    break;
                case "emballageCadeau":
                    elem = $("#ajout-paquet-emotion-component");
                    break;
                case "popinPromotionnalGift":
                    elem = $('#promotionnalCode-gift-popin');
                    break;
                case "summaryErrors":
                    elem = $('#summary_errors_list');
                    break;
                case "popinModifyEngraving":
                    elem = $("#product-engraving-popin");
                    break;
                default:
                    elem = null;
                    break;
            }

            return elem;
        },
        reflow: function () { },

        addEcrin: function (reference, lineNumber, ecrin) {
            $.ajax(
                {
                    url: '/CartResume/AddJewelleryBox',
                    data: {
                        reference: reference,
                        lineNumber: lineNumber,
                        ecrin: ecrin
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    success: function (result) {
                        if (result.IsValid) {
                            Foundation.libs.cartresume.updateCartAfterJewelleryBox(result, lineNumber);
                        } else {
                            if (result.IsRedirect) {
                                window.location.href = result.Redirect;
                            }
                        }
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },
        deleteEcrin: function (reference, lineNumber, ecrin, optionId) {
            $.ajax(
                {
                    url: '/CartResume/RemoveJewelleryBox',
                    data: {
                        reference: reference,
                        lineNumber: lineNumber,
                        ecrin: ecrin,
                        optionId: optionId
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    success: function (result) {
                        if (result.IsValid) {
                            Foundation.libs.cartresume.updateCartAfterJewelleryBox(result, lineNumber);
                        } else {
                            if (result.IsRedirect) {
                                window.location.href = result.Redirect;
                            }
                        }
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },

        addGarantie: function (reference, lineNumber, warrantyReference) {
            $.ajax(
                {
                    url: '/CartResume/AddWarrantyExtension',
                    contentType: "application/json",
                    data: {
                        reference: reference,
                        lineNumber: lineNumber,
                        warrantyReference: warrantyReference
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    success: function (result) {
                        if (result.IsValid) {
                            Foundation.libs.cartresume.updateCartAfterWarranty(result, lineNumber);
                        } else {
                            if (result.IsRedirect) {
                                window.location.href = result.Redirect;
                            }
                        }
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },
        deleteGarantie: function (reference, lineNumber, warrantyReference, optionId) {
            $.ajax(
                {
                    url: '/CartResume/RemoveWarrantyExtension',
                    data: {
                        reference: reference,
                        lineNumber: lineNumber,
                        warrantyReference: warrantyReference,
                        optionId: optionId
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    success: function (result) {
                        if (result.IsValid) {
                            Foundation.libs.cartresume.updateCartAfterWarranty(result, lineNumber);
                        } else {
                            if (result.IsRedirect) {
                                window.location.href = result.Redirect;
                            }
                        }
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },
        addProductByRef: function (reference, variantId, multiple) {
            $.ajax(
                {
                    url: '/CartResume/AddItemByRef',
                    contentType: "application/json",
                    data: {
                        reference: reference,
                        variantId: variantId,
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    success: function (result) {
                        if (result.IsValid) {
                            Foundation.libs.cartresume.updateCartAfterAdd(result);

                            var $zoneRef = $("#m-productInline__row").first();


                            if (typeof (tc_vars) !== "undefined" && typeof (tc_vars.order_products) !== "undefined") {
                                if (variantId === null) {
                                    variantId = "";
                                }

                                var order_product = tc_vars.order_products.filter(function (p) {
                                    return p.product_id === reference.toString() && p.product_size === variantId;
                                })[0];

                                if (typeof (order_product) !== "undefined") {
                                    var event = {
                                        obj: "",
                                        trigger: 'ajout_panier',
                                        options: {
                                            id: "ajout_panier",
                                            category: "ajout produit",
                                            action: order_product.product_category,
                                            label: order_product.product_name + '|' + order_product.product_id,
                                            value: order_product.product_unitprice_ati,
                                            product_brand: order_product.product_trademark,
                                            product_cat1: order_product.product_cat1,
                                            product_cat2: order_product.product_cat2,
                                            product_cat3: order_product.product_cat3,
                                            product_category: order_product.product_category,
                                            product_discount_tf: order_product.product_discount_tf,
                                            product_discount_ati: order_product.product_discount_ati,
                                            product_gravable: order_product.product_gravable,
                                            product_id: order_product.product_id,
                                            product_name: order_product.product_name,
                                            product_promo: order_product.product_promo,
                                            product_promo_label: order_product.product_promo_label,
                                            product_quantity: order_product.product_quantity,
                                            product_rating: order_product.product_rating,
                                            product_size: order_product.product_size,
                                            product_trademark: order_product.product_trademark,
                                            product_unitprice_ati: order_product.product_unitprice_ati,
                                            product_unitprice_tf: order_product.product_unitprice_tf,
                                        }
                                    };

                                    $(document).foundation('mastertag', 'track_tc_event', event);
                                }
                            }
                            Foundation.libs.cartresume.onResizeMovePromoCode();
                            Foundation.libs.common.hidePreloader();
                        }
                        else if (result.missingVariantStatus === true) {
                            Foundation.libs.cartresume.missingVariantToAddPopin(result);
                            Foundation.libs.cartresume.onResizeMovePromoCode();
                            Foundation.libs.common.hidePreloader();
                        }
                        if (multiple === true) {
                            Foundation.libs.common.showPreloader();
                        }
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },
        addMultipleProductsByRef: function (reference, variantId, quantity) {

            $.ajax(
                {
                    url: '/CartResume/AddMultipleItemsByRef',
                    contentType: "application/json",
                    data: {
                        reference: reference,
                        variantId: variantId,
                        quantity: quantity
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    complete: function (result) {

                        if (result.responseJSON.IsValid === true) {

                            Foundation.libs.cartresume.updateCartAfterAdd(result.responseJSON);

                            var $zoneRef = $("#m-productInline__row").first();

                            Foundation.libs.cartresume.onResizeMovePromoCode();
                            Foundation.libs.common.hidePreloader();
                        }
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },
        addProductFromMerchandisingAreas: function (reference) {
            this.addProductByRef(reference, null, null);
        },

        promotionnalGiftRefused: function (idGroup) {
            this.promotionalGiftChoice(idGroup);
        },
        promotionnalGiftMultipleChoice: function (idGroup, reference) {
            this.promotionalGiftMultipleChoice(idGroup, reference);
        },
        promotionnalGiftWanted: function (idGroup) {
            var $wrapperToDisable = $('#gift-wrapper');
            $wrapperToDisable.attr("style", "");
        },

        promotionalGiftChoice: function (idGroup) {
            $.ajax(
                {
                    url: '/CartResume/GiftRefusedForm',
                    contentType: "application/json",
                    data: {
                        idGroup: idGroup
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    complete: function (result) {
                        if (result.responseJSON.IsValid) {
                            Foundation.libs.cartresume.updateCart(result.responseJSON);
                        }
                        var $zoneCodePromo = $("#step-1_promotionnal_form").first();
                        var $wrapperToDisable = $('#m-promotionnalCode_wrapper');
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },

        promotionalGiftMultipleChoice: function (idGroup, reference) {
            $.ajax(
                {
                    url: '/CartResume/GiftMultipleChoiceForm',
                    contentType: "application/json",
                    data: {
                        idGroup: idGroup,
                        reference: reference,
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    complete: function (result) {
                        if (result.responseJSON.IsValid) {
                            Foundation.libs.cartresume.updateCart(result.responseJSON);
                        }
                        var $zoneCodePromo = $("#step-1_promotionnal_form").first();
                        var $wrapperToDisable = $('#m-promotionnalCode_wrapper');
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        let anchor = $(".item__content.-gift")
                        $('html,body').animate({ scrollTop: $(anchor).offset().top }, 'slow');
                        Foundation.libs.common.hidePreloader();
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            });
        },
        
        SetPromoCode: function (code) {
            $.ajax(
                {
                    method: 'POST',
                    url: '/CartResume/SetPromoCode',
                    cache: false,
                    data: {
                        Code: code,
                    },
                    beforeSend: function (e) {
                        Foundation.libs.common.showPreloader();
                    },
                    complete: function (result) {
                        if (result.responseJSON.IsValid) {
                            Foundation.libs.cartresume.updateCart(result.responseJSON);
                        }
                        Foundation.libs.cartresume.onResizeMovePromoCode();
                        Foundation.libs.common.hidePreloader();
                    }
                }
            ).fail(function (result) {
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.cartcommon.InitGlobal();

                Foundation.libs.common.hidePreloader();
            });
        },

        OnSuccessAddProductByRef: function (result) {
            if (result.IsValid) {

                if (result.WasBasketEmpty === true) {
                    $(document).foundation('cartresume', 'reloadCart');
                } else {
                    Foundation.libs.cartresume.updateCartAfterAdd(result);

                    Foundation.libs.cartresume.onResizeMovePromoCode();

                    Foundation.libs.common.hidePreloader();

                    if (result._HellobarCart && result._HellobarCart.length > 0) {
                        $(".cart__header .hellobars").remove();
                        $('.cart__header').prepend(result._HellobarCart);

                        Foundation.libs.promo.initHellobars();
                    }
                }

                Foundation.libs.common.refreshMasterTagData(result._MasterTagJson);
                Foundation.libs.common.refreshMasterTag();

                if (typeof (tc_vars) !== "undefined" && typeof (tc_vars.order_products) !== "undefined") {
                    var order_product = tc_vars.order_products.filter(function (p) {
                        return p.product_id === result.Reference && p.product_size === result.Variant;
                    })[0];

                    if (typeof (order_product) !== "undefined") {
                        var event = {
                            obj: "",
                            trigger: 'ajout_panier',
                            options: {
                                id: "ajout_panier",
                                category: "ajout par reference",
                                action: order_product.product_category,
                                label: order_product.product_name + '|' + order_product.product_id,
                                value: order_product.product_unitprice_ati,
                                product_brand: order_product.product_trademark,
                                product_cat1: order_product.product_cat1,
                                product_cat2: order_product.product_cat2,
                                product_cat3: order_product.product_cat3,
                                product_category: order_product.product_category,
                                product_discount_tf: order_product.product_discount_tf,
                                product_discount_ati: order_product.product_discount_ati,
                                product_gravable: order_product.product_gravable,
                                product_engraved: order_product.product_engraved,
                                product_id: order_product.product_id,
                                product_name: order_product.product_name,
                                product_promo: order_product.product_promo,
                                product_promo_label: order_product.product_promo_label,
                                product_quantity: order_product.product_quantity,
                                product_rating: order_product.product_rating,
                                product_size: order_product.product_size,
                                product_trademark: order_product.product_trademark,
                                product_unitprice_ati: order_product.product_unitprice_ati,
                                product_unitprice_tf: order_product.product_unitprice_tf,
                            }
                        };

                        $(document).foundation('mastertag', 'track_tc_event', event);
                    }
                }
            }
            else if (result.missingVariantStatus === true) {
                Foundation.libs.cartresume.missingVariantToAddPopin(result);
            }
            else if (result.Redirection.length > 0) {
                Foundation.libs.common.showPreloader();
                window.location = result.Redirection;
            }
        },
        OnFailureAddProductByRef: function (result) {
            Foundation.libs.cartresume.onResizeMovePromoCode();
            Foundation.libs.cartcommon.InitGlobal();

        },
        OnSuccessSaveEmballageCadeau: function (result) {
            if (result.IsValid) {
                Foundation.libs.cartresume.updateCartAfterEmballageCadeau(result);
                $('#pfp-messages-wrapper').html(result._SectionPFPMessages);
                $('#marketing-messages-wrapper').html(result._SectionMarketingMessages);
                if ($(".m-giftPackage").hasClass("-active") || $(".m-giftPackage").hasClass("-actived")) {
                    $(".m-giftPackage").toggleClass("-active");
                    $(".m-giftPackage").toggleClass("-actived");
                }

                Foundation.libs.common.refreshMasterTagData(result._MasterTagJson, true);
                Foundation.libs.common.refreshMasterTag();

                // Tracking via TagCo
                $(document).foundation('mastertag', 'track_tc_event',
                    {
                        obj: this,
                        trigger: 'emballage_cadeau',
                        options: {
                            id: 'emballage_cadeau',
                            category: 'panier',
                            action: 'emballage cadeau',
                            label: '',
                            value: ''
                        }
                    });
            }
            else if (result.HasErrors == true) {
                $(document).foundation('cartresume', 'updateErrorsEmballageCadeauForm', result);
            }
        },
        OnFailureSaveEmballageCadeau: function (result) {
            Foundation.libs.cartresume.onResizeMovePromoCode();
            Foundation.libs.cartcommon.InitGlobal();

        },
        OnSuccessUpdateCodePromo: function (result) {
            Foundation.libs.cartresume.updateCart(result);
            if (result.IsValid && result.IsPopin === true) {
                Foundation.libs.cartresume.selectVariantPromotionnalGiftPopin(result);
            } else if (result.IsValid === true && result.IsPopin === false) {
                Foundation.libs.cartresume.updateCartAfterPromotionnalGiftChoice(result);
            }

            if (result.IsValid) {
                Foundation.libs.common.refreshMasterTagData(result._MasterTagJson);
                Foundation.libs.common.refreshMasterTag();
            }
            Foundation.libs.cartresume.onResizeMovePromoCode();

            if (result._HellobarCart && result._HellobarCart.length > 0) {
                $(".cart__header .hellobars").remove();
                $('.cart__header').prepend(result._HellobarCart);

                Foundation.libs.promo.initHellobars();
            }

            Foundation.libs.common.hidePreloader();
        },
        OnFailureUpdateCodePromo: function (result) {
            Foundation.libs.cartcommon.InitGlobal();

            Foundation.libs.cartresume.onResizeMovePromoCode();
        },
        OnSuccessSetGiftEngraving: function (result) {
            if (result.IsValid) {
                Foundation.libs.cartresume.updateCartAfterPromotionnalGiftChoice(result);
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.common.hidePreloader();
            } else {
                if (result.IsException === false) {
                    $('#gift-choices-wrapper').html(result._PopinGiftEngraving);
                }
                Foundation.libs.cartresume.onResizeMovePromoCode();
                Foundation.libs.cartcommon.InitGlobal();

                Foundation.libs.common.hidePreloader();
            }
        },
        OnSuccessUpdateGiftEngraving: function (result) {
            if (result.IsValid) {
                Foundation.libs.cartresume.selectVariantPromotionnalGiftPopin(result);
            }
            Foundation.libs.cartresume.onResizeMovePromoCode();
            Foundation.libs.cartcommon.InitGlobal();

            Foundation.libs.common.hidePreloader();
        },
        OnSuccessRemoveGiftEngraving: function (result) {
            if (result.IsValid) {
                Foundation.libs.cartresume.updateCartAfterPromotionnalGiftChoice(result);
            }
            Foundation.libs.cartresume.onResizeMovePromoCode();
            Foundation.libs.cartcommon.InitGlobal();

            Foundation.libs.common.hidePreloader();
        },
        onResizeMovePromoCode: function () {
            let windowWidth = window.innerWidth;
            const promoCode = $('#cart-promo');
            if (windowWidth <= 1024) {
                const firstSubBasket = $('.resume__subbasket .subbasket__content')[0];

                promoCode.prependTo(firstSubBasket);
            } else {
                const firstItemAside = $('.resume__aside');

                promoCode.prependTo(firstItemAside)
            }
            Foundation.libs.cartresume.onClickSlidePromoCodeForm();
        },
        onClickSlidePromoCodeForm: function () {
            const formWrapper = $('#cart-promo');
            const formTitle = $('#cart-promo .form__title');
            const formActions = $('#cart-promo .form__actions');
            const promoResult = $('#cart-promo .promotionnal__result');

            var isOpened = true;
            formWrapper.addClass('-open');

            formTitle.on('click', () => {
                formActions.slideToggle();
                promoResult.slideToggle();
                isOpened = !isOpened;

                isOpened ? formWrapper.addClass('-open') : formWrapper.removeClass('-open');
            })
        },
        OnLoadIsCartEmpty: function () {
            let $parent = $('.cart__resume');
            let $breadcrumb = $('.header__breadcrumb');

            $parent.children('.cart__empty').length === 1
                ? $breadcrumb.css('visibility', 'hidden')
                : ''
        }
    };
}(jQuery, this, this.document));





// Invalidation de Cache sur le bouton Back de Safari sur Mac et iPad
window.onpageshow = function (event) {
    if (event.persisted) {
        window.location.reload()
    }
}


//$(window).resize(function () {
//    Foundation.libs.cartresume.onResizeMovePromoCode();
//})

$(document).ready(function () {
    Foundation.libs.cartresume.onResizeMovePromoCode();



    Foundation.libs.cartresume.OnLoadIsCartEmpty();

    LoadEngravingPreviewFont()
})

LoadEngravingPreviewFont = () => {
    $('span[data-engraving-font]').each(function (index, element) {
        let el = $(element)[0];
        let font = "f" + el.dataset.engravingFont

        $(element).css("font-family", font);
    });
}